import $ from 'zepto';
import { onDocumentReady } from '../../main';
import { visibilityManagerSelector } from '../../utils/constants/classes';
import { log } from '../../utils';
import { DATA_TYPE } from '../../utils/constants/dataKeys';
import byFields from './strategies/byFields';

const $body = $(document.body);

const types = {
  FIELD: byFields.type,
};

const visibilityStrategies = {
  [types.FIELD]: byFields.init,
};

const eachElement = (index, item) => {
  const $element = $(item);
  const type = $element.data(DATA_TYPE);

  const strategy = visibilityStrategies[type];

  if (!strategy) {
    return log.error(`VisibilityManager: '${type}' strategy doesn't exist`);
  }

  return strategy($element);
};

export default function initVisibilityManager(context = $body) {
  $(context).find(visibilityManagerSelector).each(eachElement);
}

onDocumentReady('VisibilityManager', () => {
  initVisibilityManager();
});
